import React from "react";
import { Redirect, Route } from "react-router-dom";

interface RouteModel {
  [key: string]: any;
  component: React.ComponentType<any>
}

const PrivateRoute = (route: RouteModel) => {
  const { component: Component, ...rest } = route;
  return (
    <Route
      {...rest}
      render={(props) =>
        <Component {...props} />
      }
    ></Route>
  );
};

export default PrivateRoute;
